import { useEffect, useState } from 'preact/hooks';
import { getBetInfo } from 'src/common/api';
import { BetInfo } from 'src/common/types';
import { defaultRTP } from 'src/app/constants';

export default function useResultRender() {
    const [betData, setBetData] = useState<BetInfo | undefined>(undefined);
    const { search } = window.location;
    const searchParams = new URLSearchParams(search);
    const betId = searchParams.get('betId');
    const locale = searchParams.get('locale');
    const rtp = searchParams.get('rtp') || defaultRTP;
    const betPayoutConverted = searchParams.get('betPayoutConverted');
    const betAmountConverted = searchParams.get('betAmountConverted');

    if (!betId) return null;

    useEffect(() => {
        const bodyElement = document.getElementsByTagName('body')[0];
        bodyElement.classList.add('modal-body');
        try {
            getBetInfo({
                headers: {},
                betId,
            }).then(({ data }) => setBetData(data));
        } catch (error) {
            console.log('getMyBetsError', error);
        }

        if (window.self !== window.top) {
            // The page is inside an iframe
        } else {
            bodyElement.classList.add('single-page');
            // The page is not in an iframe
        }
    }, []);
    if (!betData) return null;

    return {
        ...betData,
        locale,
        betPayoutConverted,
        betAmountConverted,
        rtp: Number(rtp),
    };
}
